import React from "react";

import RouteListRenderer from "common/RouteListRenderer";
import { EASY_NAVIGATION_TEXT } from "constants/common";

const PAGE_NAME = "Kolkata Trams";

const KolkataTrams = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Hereby we present, the legendary trams of Kolkata, operated by WBTC.
          From the 1st horse driven trams in 1873 to the current power-line
          based trams (AC / Non AC), trams have definitely seen the rise of city
          Kolkata. However, due to lack of maintenance, their services have been
          shrunk to only a few routes. Fortunately people have still remembered
          trams as an ecological mode of mass transport and trams will continue
          to serve the city for longer period of time.
        </p>

        <div className="bg-accent-back drop-shadow-lg rounded-md px-10 py-4 mt-12">
          <p className="my-4 italic">{EASY_NAVIGATION_TEXT}</p>
        </div>
      </RouteListRenderer>
    </main>
  );
};

export default KolkataTrams;
